var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height pa-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","md":"6"}},[_c('ListPlaces')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }